import React from 'react';
import { Link } from 'react-router-dom';
import { Spinner } from 'react-bootstrap';
import i18n from '../../../../i18n';
import { confirmOABPayment } from '../RopPayment/services/ropPaymentService';


// Target of CLIENT_SUCCESS_URL, reached after OAB redirects the browser
// straight back here (same pattern as WalletPaymentSuccess.js — no backend
// callback in between). Query params come from gotoOABPayment in
// RopPayModal.jsx: ptype, type, amt, ref.
//
// Calls OabPaymentController@confirm with { reference, status: 'success' }.
// That call is idempotent server-side: if this page is refreshed, opened
// twice, or the call otherwise fires more than once for the same ref, the
// backend finds the payments row already finalized and returns the stored
// result WITHOUT re-applying the amount again.
export class RopPaymentSuccess extends React.Component {
  constructor(props) {
    super(props);
    const urlSearchParams = new URLSearchParams(window.location.search);
    const params = Object.fromEntries(urlSearchParams.entries());

    this.state = {
      // `mzref` — NOT `ref`. OAB appends its own `ref`/`invoice` params
      // onto the URL we gave it, and `ref` collided with our own param
      // name (last value wins when parsing duplicate query keys), so this
      // was silently reading OAB's ref instead of ours. See RopPayModal.
      reference: params.mzref,
      is_error: false,
      is_loading: false,
    };
  }

  componentDidMount() {
    this.confirmPayment();
  }

  async confirmPayment() {
    if (!this.state.reference) {
      this.setState({ is_error: true });
      return;
    }

    this.setState({ is_loading: true });
    try {
      const response = await confirmOABPayment({
        reference: this.state.reference,
        status: 'success',
      });

      if (response && response.success) {
        this.setState({ is_error: false, is_loading: false });
      } else {
        this.setState({ is_error: true, is_loading: false });
      }
    } catch (error) {
      console.error('Error confirming online payment:', error);
      this.setState({ is_error: true, is_loading: false });
    }
  }

  render() {
    const { is_error, is_loading, reference } = this.state;
    return (
      <React.Fragment>
        <section>
          <div
            className="bannerimg cover-image sptb-2"
            data-image-src="../assets/images/banners/banner2.jpg"
          >
            <div className="header-text mb-0">
              <div className="container">
                <div className="text-center text-white ">
                  <h1 className="">{is_error ? 'Payment Error!!!' : 'Payment Success!!!'}</h1>
                  <ol className="breadcrumb text-center">
                    <li className="breadcrumb-item">
                      <Link exact="true" to="/">
                        Home
                      </Link>
                    </li>
                  </ol>
                </div>
              </div>
            </div>
          </div>
        </section>

        <section className="sptb">
          <div className="container">
            {is_loading && (
              <div className="container text-center">
                <Spinner animation="grow" size="lg" />
              </div>
            )}
            {!is_loading && (
              <div className="container text-center">
                <div className="display-1 mb-8"></div>
                <h1 className={is_error ? 'h2 mb-7 text-danger' : 'h2 mb-7 text-success'}>
                  {is_error ? 'Payment Error' : 'Payment Success'}
                </h1>
                <p
                  className={
                    is_error
                      ? 'h4 font-weight-Automatic text-danger mb-8 leading-Automatic'
                      : 'h4 font-weight-Automatic text-success mb-8 leading-Automatic'
                  }
                >
                  {!is_error && <span>Success!!!. Your auction payment has been recorded.</span>}
                  {is_error && <span>Error!!! Payment not completed!!!.</span>}
                </p>
                {reference && <p className="text-muted small">Reference: {reference}</p>}
                <Link className="btn btn-warning" to="/">
                  {i18n.t('back')}
                </Link>
                &nbsp;
                <Link className="btn btn-danger" to="/rop">
                  {i18n.t('auction')}
                </Link>
              </div>
            )}
          </div>
        </section>
      </React.Fragment>
    );
  }
}